import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76bf68e0")

_pushScopeId("data-v-76bf68e0")
const _hoisted_1 = /*#__PURE__*/_createVNode("a", { style: {"color":"#fff","text-decoration":"none"} }, "安装包下载", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除数据")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_7 = { class: "corePerformance" }
const _hoisted_8 = { class: "flex_bt" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Resource资源加载信息", -1)
const _hoisted_11 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_12 = { class: "corePerformance" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "Resource资源对比", -1)
const _hoisted_15 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_16 = { class: "flex_bt" }
const _hoisted_17 = { class: "corePerformance" }
const _hoisted_18 = { class: "flex_bt" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "MethodCost函数耗时信息", -1)
const _hoisted_21 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_22 = { class: "corePerformance" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "MethodCost函数耗时对比", -1)
const _hoisted_25 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_26 = { class: "flex_bt" }
const _hoisted_27 = { class: "corePerformance" }
const _hoisted_28 = { class: "flex_bt" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "Jank卡顿耗时信息", -1)
const _hoisted_31 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_32 = { class: "corePerformance" }
const _hoisted_33 = { class: "flex_bt" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", null, "Jank卡顿耗时对比", -1)
const _hoisted_36 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_37 = { class: "flex_bt" }
const _hoisted_38 = { class: "corePerformance" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("span", null, "趋势图", -1)
const _hoisted_41 = {
  class: "FPStrend",
  style: {"width":"100%","height":"350px"}
}
const _hoisted_42 = { class: "labelStyle" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%","height":"350px"},
  id: "performance_line"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_h7 = _resolveComponent("h7")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        label: "数据类型",
                        class: "light_style"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (
                  _ctx.allOption([
                    'type_data',
                    'device',
                    'scene',
                    'subtype',
                    'log',
                    'dateContrast',
                  ])
                )),
                            modelValue: _ctx.data_type,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.data_type = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    model: _ctx.filterList,
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        label: "日期",
                        class: "light_style"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (
                  _ctx.allOption([
                    'device',
                    'scene',
                    'subtype',
                    'log',
                    'dateContrast',
                  ])
                )),
                            modelValue: _ctx.filterList.date,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterList.date = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.date,
                                  label: item.date,
                                  value: item.date
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "机型  " }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.allOption(['scene', 'subtype', 'log', 'dateContrast']))),
                            modelValue: _ctx.filterList.device,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterList.device = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.device_id,
                                  label: item.name,
                                  value: item.device_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.allOption(['subtype', 'log', 'dateContrast']))),
                            modelValue: _ctx.filterList.scene,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterList.scene = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.chinese,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "light_style",
                        label: "测试子类型"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.allOption(['log', 'dateContrast']))),
                            modelValue: _ctx.filterList.subtype,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterList.subtype = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtypeOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.subtype,
                                  label: item.chinese,
                                  value: item.subtype
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "日志" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.allOption(['dateContrast']))),
                            modelValue: _ctx.filterList.Journa,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterList.Journa = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.JournaOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id_test,
                                  label: item.time,
                                  value: item.id_test
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            onClick: _ctx.packageBtn,
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"}
                          }, {
                            default: _withId(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"},
                            onClick: _ctx.deleteBtn
                          }, {
                            default: _withId(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"},
                            onClick: _ctx.editBtn
                          }, {
                            default: _withId(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible1,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogFormVisible1 = $event)),
                    width: "30%"
                  }, {
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                        }, {
                          default: _withId(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.dialogFormVisible2
                        }, {
                          default: _withId(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        class: "demo-form-inline",
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, {
                            class: "reportName",
                            label: "日志文件"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                size: "small",
                                class: "report-input",
                                modelValue: _ctx.logName,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.logName = $event)),
                                autocomplete: "off",
                                width: "500"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_9,
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.resource_input,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.resource_input = $event)),
                          onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.recordSearch('resource_input'))),
                          placeholder: "搜索",
                          "prefix-icon": "el-icon-search",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_el_table, {
                        data: _ctx.lightPerfResource.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "resource_name",
                            label: "资源名",
                            width: "800"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "avg_duration",
                            label: "平均耗时"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "duration",
                            label: "总耗时"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "count",
                            label: "次数"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage1,
                        "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => (_ctx.currentPage1 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.lightPerfResource?.count,
                        onCurrentChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleCurrentChange('resource_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", null, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_13,
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          model: _ctx.filterList,
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "日期选择" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.filterList.dateResource,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.filterList.dateResource = $event)),
                                  multiple: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": "",
                                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.cost('resource'))),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lightPerfDateContrast, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.date,
                                        label: item.date,
                                        value: item.date
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]),
                      _createVNode(_component_el_table, {
                        data: _ctx.ResourceTable.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resourceList.label, (item) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                              prop: item,
                              key: item,
                              label: item == 'resource_name' ? '资源名' : item
                            }, null, 8, ["prop", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage4,
                        "onUpdate:currentPage": _cache[22] || (_cache[22] = ($event: any) => (_ctx.currentPage4 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.resourceList.list?.length,
                        onCurrentChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleCurrentChange1('resource_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_19,
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.method_input,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.method_input = $event)),
                          onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.recordSearch('method_input'))),
                          placeholder: "搜索",
                          "prefix-icon": "el-icon-search",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode(_component_el_table, {
                        data: _ctx.lightPerfmethod.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "function_name",
                            label: "函数名",
                            width: "800"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "avg_duration",
                            label: "平均值"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage3,
                        "onUpdate:currentPage": _cache[26] || (_cache[26] = ($event: any) => (_ctx.currentPage3 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.lightPerfmethod.count,
                        onCurrentChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleCurrentChange('method_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", null, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_23,
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          model: _ctx.filterList,
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "日期选择" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.filterList.dateMethod,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.filterList.dateMethod = $event)),
                                  multiple: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": "",
                                  onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.cost('method'))),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lightPerfDateContrast, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.date,
                                        label: item.date,
                                        value: item.date
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]),
                      _createVNode(_component_el_table, {
                        data: _ctx.MethodTable.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.methodList.label, (item) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                              key: item,
                              label: item == 'function_name' ? '函数名' : item
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(typeof scope.row[item] === "number"
                        ? scope.row[item].toFixed(2)
                        : scope.row[item]), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage5,
                        "onUpdate:currentPage": _cache[30] || (_cache[30] = ($event: any) => (_ctx.currentPage5 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.methodList.list?.length,
                        onCurrentChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleCurrentChange1('method_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_29,
                          _hoisted_30
                        ]),
                        _: 1
                      }),
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.jank_input,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.jank_input = $event)),
                          onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.recordSearch('jank_input'))),
                          placeholder: "搜索",
                          "prefix-icon": "el-icon-search",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_31, [
                      _createVNode(_component_el_table, {
                        data: _ctx.lightPerfJank.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "function_name",
                            label: "函数名",
                            width: "800"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "duration",
                            label: "次数/总耗时"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "avg_duration",
                            label: "占比/平均时间"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", null, _toDisplayString((scope.row.avg_duration * 100).toFixed(2) + "%"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage2,
                        "onUpdate:currentPage": _cache[34] || (_cache[34] = ($event: any) => (_ctx.currentPage2 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.lightPerfJank.count,
                        onCurrentChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleCurrentChange('jank_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _createVNode("div", _hoisted_33, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_34,
                          _hoisted_35
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_36, [
                      _createVNode("div", _hoisted_37, [
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          model: _ctx.filterList,
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "日期选择" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.filterList.dateJank,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.filterList.dateJank = $event)),
                                  multiple: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": "",
                                  onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.cost('jank'))),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lightPerfDateContrast, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.date,
                                        label: item.date,
                                        value: item.date
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]),
                      _createVNode(_component_el_table, {
                        data: _ctx.JankTable.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jankList.label, (item) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                              key: item,
                              label: item == 'function_name' ? '函数名' : item
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(typeof scope.row[item] === "number"
                        ? scope.row[item].toFixed(2)
                        : scope.row[item]), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage6,
                        "onUpdate:currentPage": _cache[38] || (_cache[38] = ($event: any) => (_ctx.currentPage6 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.jankList.list?.length,
                        onCurrentChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.handleCurrentChange1('jank_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                      default: _withId(() => [
                        _hoisted_39,
                        _hoisted_40
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form, {
                      class: "spacForm",
                      size: "mini",
                      model: _ctx.filterList,
                      inline: true
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "函数选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.filterList.trendOp,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.filterList.trendOp = $event)),
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.allOption1())),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lightPerfFunctions.functions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"]),
                    _createVNode("div", _hoisted_41, [
                      _createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_42, _toDisplayString(_ctx.lightPerfTrend.device_name), 1),
                          _hoisted_43
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})